const REPO_FILTER_PREFIX = 'repo:'

export type ParsedInboxFilterQuery = {
  repos: string[]
}

export function uniqueTerms(terms: string[]): string[] {
  return Array.from(new Set(terms))
}

export function buildInboxFilterQuery({repos}: ParsedInboxFilterQuery): string {
  const terms = [...uniqueTerms(repos).map(repo => `${REPO_FILTER_PREFIX}${repo}`)]

  return terms.join(' ').trim()
}
